import { useState } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { downloadFile } from 'helper';
import { exportAllPartnersRatingByPartnerExcel } from '../api';

export function useExportAllPartnersRatingByPartnerExcelReport() {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const exportAllPartnersRatingByPartnerExcelReport = async (config?: AxiosRequestConfig) => {
    setLoading(true);

    try {
      downloadFile(
        await exportAllPartnersRatingByPartnerExcel(config),
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Отчет по всем партнерам.xlsx',
      );
    } catch (error) {
      addError((error as AxiosError).response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, exportAllPartnersRatingByPartnerExcelReport };
}
